<template>
    <form @submit.prevent="register" ref="create-account" method="post" class="material-form details-form" data-form-name="Online Service Booking - Create Password">
        <div class="login__create-account">
            <div v-if="showEmail === true" class="login__password-container">
                <email :readonly="true" />
            </div>
            <div class="login__password-container">
                <input class="form-element__input"
                    :type="passwordInputType"
                    name="password"
                    id="password"
                    :placeholder="placeholderText"
                    data-validate="password"
                    data-validate-message="Please enter a password">
                <div class="login__toggle-password" @click="togglePasswordVisibility('password')">
                    <img :src="passwordEyeIcon" alt="Toggle Password" class="login__eye-icon" id="eye-icon">
                </div>
            </div>
            <div class="login__password-container">
                <input class="form-element__input"
                    :type="confirmPasswordInputType"
                    name="password_confirmation"
                    id="password-confirmation"
                    placeholder="Repeat password*"
                    data-validate='confirm_password'
                    data-validate-confirm-password-target="#password">
                <div class="login__toggle-password" @click="togglePasswordVisibility('confirm')">
                    <img :src="confirmEyeIcon" alt="Toggle Password" class="login__eye-icon" id="eye-icon-confirm">
                </div>
            </div>
            <button type="submit" class="btn btn--primary btn--full-width">REGISTER</button>
        </div>
    </form>
</template>

<script>
import { mapGetters, mapMutations, mapActions} from "vuex";
import Email from "../../../core/components/Forms/Email.vue";
export default {
    components: {
        Email
    },
    props: {
        formIdentifier: {
            type: String,
            default: "form",
        },
        registration: {
            type: String,
            default: null,
        },
        mileage: {
            type: Number,
            default: null,
        },
        locationId: {
            type: Number,
            default: null,
        },
        showEmail: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            createAccountPreference: "",
            passwordInputType: 'password',
            confirmPasswordInputType: 'password',
            eyeIconOpen: '/images/my-account/eye-open.svg',
            eyeIconClosed: '/images/my-account/eye-closed.svg',
            createAccount: false,
            validator: null,
        };
    },
    mounted() {
        this.validator = new ContactFormValidator({
            element: this.$refs['create-account'],
            vueForm: true,
            redesign: true,
        });
    },
    methods: {
        ...mapMutations("Auth", ["setAuthenticated", "setHasAccount", "setVehicleAdded", "setShowLoginModal"]),
        
        storeValuation() {
            if (this.valuationExtendedExists) {
                return this.$store.dispatch('ValuationExtended/storeValuation');
            }
        },

        goToPosition() {
            if (this.valuationExtendedExists) {
                return this.$store.dispatch('ValuationTool/goToPosition', 'valuation-start');
            }
        },

        async register(){
            this.validator.errorResponse();
            if (!await this.validator.isValid()) {
                return;
            }

            const formData = new FormData(this.$refs['create-account']);

            formData.set("location-id", this.customerData.locationId || this.locationId);
            formData.set("first-name", this.customerData.firstName);
            formData.set("last-name", this.customerData.lastName);
            formData.set("email", this.customerData.email);
            formData.set("tel", this.customerData.telephone);
            formData.set("title", this.customerData.title);
            formData.set("vehicle", JSON.stringify(this.vehicleDetailsFormatted));

            this.validator.preventInput();

            axios
                .post("/api/register-after-submission", formData)
                .then((response) => {
                    this.validator.allowInput();
                    this.setAuthenticated(true)
                    this.setShowLoginModal({show: false, type: ''})
                    this.setVehicleAdded(response.data.vehicle_added)
                    this.setHasAccount(response.data.registered)
                    if (this.valuationExtendedExists) {
                        this.storeValuation();
                        this.goToPosition();
                    }
                    const userName = this.customerData.firstName;
                    const myAccountSpan = document.getElementById('header-menu__my-account');
                    if (myAccountSpan) {
                        myAccountSpan.textContent = userName;
                    }
                    return;
                })
                .catch((error) => {
                    this.validator.errorResponse(error);
                    console.error(error);
                    return;
                });
        },
        togglePasswordVisibility(inputId) {
            if (inputId == 'password') {
                if (this.passwordInputType == 'password') {
                    this.passwordInputType = 'text';
                    return;
                }
                this.passwordInputType = 'password';
                return;
            }
            if (this.confirmPasswordInputType == 'password') {
                this.confirmPasswordInputType = 'text';
                return;
            }
            this.confirmPasswordInputType = 'password';
            return;
        },
    },
    computed: {
        ...mapGetters('CustomerData', ['customerData']),

        valuationExtendedExists() {
            return this.$store.hasModule("ValuationExtended");
        },

        vehicleDetailsFormatted() {
            if (this.$store.hasModule('OSB')) {
                return this.$store.getters['OSB/vehicleDetailsFormatted'];
            } else {
                return this.$store.getters['ValuationTool/vehicleDetailsFormatted'];
            }
        },
        
        passwordEyeIcon() {
            return this.passwordInputType == 'password' ? this.eyeIconClosed : this.eyeIconOpen;
        },

        confirmEyeIcon() {
            return this.confirmPasswordInputType == 'password' ? this.eyeIconClosed : this.eyeIconOpen;
        },

        placeholderText() {
            if (this.createAccount) {
                return 'Create a password*';
            }
            return 'Password*';
        },

        fullFormIdentifier() {
                return this.formIdentifier + "-" + this._uid;
            },
        },
};
</script>

<style lang="scss">
  .validation-error{
    margin: 0 auto 10px;
    padding: 0;
    ul{
        list-style-image: none;
    }
    li{
        background-color: #ef7d00;
        color:white;
        list-style-image: none;
        padding: 8px 15px;
        border-radius: 10px;
        box-shadow: 0px 11px 24px rgba(0, 0, 0, 0.07);
    }
  } 
</style>